import React from "react"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import styles from "./index.module.css"

/**
 * The label bar that names a blackout inside a calendar day — red when the day is fully
 * closed, dark for a partial closure or a crew-off day. Renders as a button when `onClick`
 * is given, since in the design it opens the day details panel.
 */
const BlackoutReasonChip = ({ label, variant = "full", count, showCount = false, onClick, className = "" }) => {
  const suffix = showCount && count ? ` (${count})` : ""
  const content = (
    <>
      <span className={styles.label}>{`${label}${suffix}`}</span>
      {onClick && <Icon name="ChevronRight" width={16} height={16} color="currentColor" />}
    </>
  )

  const chipClassName = `${styles.chip} ${styles[variant]} ${className}`

  if (!onClick) return <span className={chipClassName}>{content}</span>

  return (
    <button type="button" className={chipClassName} onClick={onClick}>
      {content}
    </button>
  )
}

BlackoutReasonChip.propTypes = {
  label: PropTypes.string.isRequired,
  /** "full" closes the whole day (red); "partial" covers part of it (dark). */
  variant: PropTypes.oneOf(["full", "partial"]),
  /** Number of blackouts on the day. */
  count: PropTypes.number,
  /** Appends the count, as the week header does: "Partial Blackout (2)". */
  showCount: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default BlackoutReasonChip
